<template>
  <span v-if="!task.discarded">
    <i class="material-icons pointer" data-toggle="modal" :data-target="'#deleteModal' + task.id">delete_forever</i>
    <div class="modal fade" :id="'deleteModal' + task.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure you want to delete this todo?</h5>
          </div>
          <div class="modal-body">
            <div> Are you sure you want to delete? -
              <em>
                {{task.title}}
              </em>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="deleteTask(task)">Delete Todo</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    deleteTask(task) {
      api.deleteTask(task.id).then(response => {
        $('body').removeClass('modal-open')
        $(".modal-backdrop").hide();
      });
    },
  }
}
</script>
